import { useTranslation } from 'react-i18next';
import { TypeToConfirmDialog } from '@/shared/components/custom/type-to-confirm-dialog/TypeToConfirmDialog';

interface ProjectDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projectName: string;
  isPending: boolean;
  onConfirm: () => Promise<void>;
}

export function ProjectDeleteDialog({
  open,
  onOpenChange,
  projectName,
  isPending,
  onConfirm,
}: ProjectDeleteDialogProps) {
  const { t } = useTranslation('settings');

  return (
    <TypeToConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('projectInfo.deleteDialog.title')}
      description={t('projectInfo.deleteDialog.typeToConfirm')}
      confirmValue={projectName}
      confirmLabel={t('projectInfo.deleteDialog.typeToConfirm')}
      onConfirm={() => void onConfirm()}
      isPending={isPending}
      confirmButtonLabel={t('projectInfo.deleteDialog.confirmButton')}
      destructive
      testId="settings-project-delete"
    >
      <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-4 space-y-3">
        <p className="text-sm font-medium text-destructive">
          {t('projectInfo.deleteDialog.warning')}
        </p>
        <ul className="text-sm text-muted-foreground space-y-1.5 list-disc list-inside">
          <li>{t('projectInfo.deleteDialog.consequence1')}</li>
          <li>{t('projectInfo.deleteDialog.consequence2')}</li>
          <li>{t('projectInfo.deleteDialog.consequence3')}</li>
        </ul>
      </div>
    </TypeToConfirmDialog>
  );
}
